import { Brand } from '@blade/std-lib'

export const DeviceIdTypeId = 'tradebot-tma/DeviceId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DeviceIdTypeId = typeof DeviceIdTypeId

export type DeviceId = Brand.Branded<string, DeviceIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeviceId = Brand.nominal<DeviceId>()
